/**
 * Beschreibungen für Template-Variablen
 * Diese Texte werden als Tooltips bei den Variablen angezeigt
 * Basiert auf dem tatsächlichen Datenfluss aus email.service.helper.ts
 */

export const variableDescriptions: Record<string, string> = {
    // ============================================
    // BUCHER - Grundinformationen
    // ============================================
    bookerSalutationFormal: "Formale Anrede z.B. 'Sehr geehrter Herr' oder 'Sehr geehrte Frau' (abhängig vom Geschlecht)",
    bookerSalutation: "Informelle Anrede z.B. 'Hallo' (unabhängig vom Geschlecht)",
    bookerSalutationInformelSwiss: "Informelle Schweizer Anrede z.B. 'Grüezi Herr' oder 'Grüezi Frau' (abhängig vom Geschlecht, mit Nachname)",
    bookerFirstName: "Vorname des Buchenden",
    bookerLastName: "Nachname des Buchenden",
    bookerFullName: "Vollständiger Name: Vorname + Nachname des Buchenden",
    bookerGender: "Geschlechtsangabe des Buchenden (männlich/weiblich/divers/unbekannt)",
    bookerEmail: "E-Mail-Adresse des Buchenden",
    bookerAttendees: "Formatierte Liste aller Kursteilnehmer (Vorname + Nachname) dieses Buchenden",

    // ============================================
    // BUCHER - Adressdaten
    // ============================================
    bookerAddress: "Vollständige formatierte Adresse: Straße, Hausnummer, PLZ, Stadt",
    bookerStreet: "Straße des Buchenden",
    bookerPostCode: "Postleitzahl des Buchenden",
    bookerCity: "Stadt/Wohnort des Buchenden",
    bookerAddition: "Text der im Feld 'Zusatz' des Buchenden eingetragen wurde",

    // ============================================
    // BUCHER - Zusatzinformationen
    // ============================================
    bookerCustomerNumber: "Eindeutige Kundennummer (Präfix + Nummer) z.B. 'K-12345'",
    bookerBirthday: "Geburtsdatum des Buchenden (formatiert nach Sprache/Region)",
    bookerHealthInsuranceFund: "Name der Krankenkasse des Buchenden",
    bookerInitialContact: "Datum des ersten Kontakts mit diesem Buchenden",
    bookerNewsLetter: "Newsletter-Abonnement: 'Ja' oder 'Nein'",
    bookerAnnotation: "Inhalte aus dem Feld Anmerkungen zum Buchenden",
    bookerMobileNumber: "Mobilfunknummer des Buchenden",
    bookerPhoneNumber: "Festnetznummer/Telefon des Buchenden",
    bookerDSGVO: "DSGVO-Zustimmung: 'Ja' oder 'Nein'",

    // ============================================
    // BUCHER - Bankinformationen
    // ============================================
    bookerIban: "IBAN für Überweisungen oder SEPA-Lastschriften (falls vorhanden)",
    bookerBankName: "Name der Bank/Kreditinstitut (falls vorhanden)",
    bookerSepaAccountOwner: "Name des Kontoinhabers (kann von Bucher-Name abweichen) (falls vorhanden)",
    bookerPaymentMethods: "Alle für diesen Buchenden verfügbaren Zahlungsmethoden (falls vorhanden)",

    // ============================================
    // ATTENDEE - Teilnehmerinformationen
    // ============================================
    attendeeFirstName: "Vorname des Kursteilnehmers",
    attendeeLastName: "Nachname des Kursteilnehmers",
    attendeeFullName: "Vollständiger Name: Vorname + Nachname des Teilnehmers",
    attendee: "Shortcut: Vollständiger Name des Teilnehmers",
    attendeeGender: "Geschlecht des Teilnehmers (männlich/weiblich/divers/unbekannt)",
    attendeeBirthday: "Geburtsdatum des Teilnehmers (formatiert nach Sprache/Region)",
    attendeeAge: "Alter des Teilnehmers in Jahren (berechnet aus Geburtsdatum)",
    attendeeAddition: "Adresszusatz des Teilnehmers", // not sure about this
    attendeeMember: "Mitgliedschafts-Status des Teilnehmers (true/false)",
    attendeeAnnotation: "Notizen/Anmerkungen zum Teilnehmer",
    attendeeBookings: "Formatierte Liste aller Buchungen dieses Teilnehmers",
    attendeeBooker: "Name des Buchenden für diesen Teilnehmer (Vorname + Nachname)",
    attendeeCustomerNumber: "Eindeutige Kundennummer des Teilnehmers",

    // ============================================
    // BOOKING - Buchungsgrundinfos
    // ============================================
    bookingNumber: "Buchungsnummer mit Präfix z.B. 'B-5678' oder 'P-1234'",
    courseNumber: "Kursnummer mit Präfix z.B. 'KU-2024-001'",
    courseType: "Kursart/Kategorie z.B. 'Anfänger', 'Fortgeschrittene', 'Kinder'",
    bookingType: "Art der Buchung z.B. 'Buchung', 'Wartelistenplatz', 'Platzreservierung'",

    // ============================================
    // BOOKING - Preise & Zahlungen
    // ============================================
    grossPrice: "Gesamtpreis brutto inkl. MwSt. (formatiert mit Währung)",
    netPrice: "Nettopreis ohne MwSt. (formatiert mit Währung)",
    bookingTaxRate: "MwSt.-Satz in Prozent z.B. '19%' oder '7%'",
    creditedBalance: "Guthaben, welches verrechnet wurde (formatiert mit Währung)",
    hasCreditedBalance: "Ob Guthaben verrechnet wurde (boolean)",
    creditedBalanceNote: "Satz 'Verrechnetes Guthaben: 20,00 €' – bleibt leer, wenn kein Guthaben verrechnet wurde (z. B. beim Nachrücken)",
    payDate: "Zahlungsdatum ('offen' wenn noch nicht bezahlt)",
    paymentMethod: "Zahlungsmethode z.B. 'Überweisung', 'Lastschrift', 'Bar'",
    paymentType: "Zahlungsart/Plan z.B. 'Vorkasse', 'Monatlich', 'Vor Ort'",
    bookingSettled: "Ist die Rechnung gestellt: 'Ja' oder 'Nein'",
    bookingSpecialPrice: "Hat der Bucher einen Sonderpreis erhalten: true/false",

    // ============================================
    // BOOKING - Kursdetails
    // ============================================
    location: "Kursstandort/Ort (z.B. Name des Kursstandortes)",
    venue: "Raum/Becken/Trainingsfläche z.B. 'Olympiabecken', 'Raum 1', '50m Becken'",
    bookingLocationName: "Name des Kursstandortes",
    bookingLocationStreet: "Straße des Kursstandortes",
    bookingLocationZipCode: "PLZ des Kursstandortes",
    bookingLocationCity: "Stadt des Kursstandortes",
    bookingLocationEmailVariableInfo: "Inhalte aus dem Feld 'Standort-Text für Vorlagen' in den Standorteinstellungen",
    bookingCourseDescription: "Subtitel des Kurses",
    bookingCourseAnnotation: "Anmerkungen aus dem Feld 'Anmerkungen (Kurs)' in den Kurseninstellungen",

    // ============================================
    // BOOKING - Kurstermine
    // ============================================
    firstCourseLesson: "Datum und Uhrzeit der ersten Kurseinheit",
    lastCourseLessonDate: "Datum der letzten Kurseinheit",
    courseLessonCount: "Gesamtzahl aller Kurseinheiten",
    bookingCourseUnits: "Detaillierte Tabelle mit Datum und Uhrzeit aller Kurseinheiten",

    // ============================================
    // BOOKING - Kurseinheit Termine (01-20)
    // ============================================
    courseLessonDate01: "Datum und Uhrzeit der 1. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate02: "Datum und Uhrzeit der 2. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate03: "Datum und Uhrzeit der 3. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate04: "Datum und Uhrzeit der 4. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate05: "Datum und Uhrzeit der 5. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate06: "Datum und Uhrzeit der 6. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate07: "Datum und Uhrzeit der 7. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate08: "Datum und Uhrzeit der 8. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate09: "Datum und Uhrzeit der 9. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate10: "Datum und Uhrzeit der 10. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate11: "Datum und Uhrzeit der 11. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate12: "Datum und Uhrzeit der 12. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate13: "Datum und Uhrzeit der 13. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate14: "Datum und Uhrzeit der 14. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate15: "Datum und Uhrzeit der 15. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate16: "Datum und Uhrzeit der 16. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate17: "Datum und Uhrzeit der 17. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate18: "Datum und Uhrzeit der 18. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate19: "Datum und Uhrzeit der 19. Kurseinheit (leer wenn Einheit nicht existiert)",
    courseLessonDate20: "Datum und Uhrzeit der 20. Kurseinheit (leer wenn Einheit nicht existiert)",

    // ============================================
    // BOOKING - Gebuchte Einheiten (nur wenn Einzelbuchung aktiviert)
    // ============================================
    bookedCourseLessonCount: "Anzahl der tatsächlich vom Teilnehmer gebuchten Einheiten",
    firstBookedCourseLesson: "Datum der ersten gebuchten Einheit",
    lastBookedCourseLessonDate: "Datum der letzten gebuchten Einheit",
    bookedCourseLessonDate01: "Datum und Uhrzeit der 1. gebuchten Einheit (leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate02: "Datum und Uhrzeit der 2. gebuchten Einheit (leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate03: "Datum und Uhrzeit der 3. gebuchten Einheit (leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate04: "Datum und Uhrzeit der 4. gebuchten Einheit (leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate05: "Datum und Uhrzeit der 5. gebuchten Einheit (leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate06: "Datum und Uhrzeit der 6. gebuchten Einheit (leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate07: "Datum und Uhrzeit der 7. gebuchten Einheit (leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate08: "Datum und Uhrzeit der 8. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate09: "Datum und Uhrzeit der 9. gebuchten Einheit (leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate10: "Datum und Uhrzeit der 10. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate11: "Datum und Uhrzeit der 11. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate12: "Datum und Uhrzeit der 12. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate13: "Datum und Uhrzeit der 13. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate14: "Datum und Uhrzeit der 14. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate15: "Datum und Uhrzeit der 15. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate16: "Datum und Uhrzeit der 16. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate17: "Datum und Uhrzeit der 17. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate18: "Datum und Uhrzeit der 18. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate19: "Datum und Uhrzeit der 19. gebuchten Einheit(leer wenn Einheit nicht existiert)",
    bookedCourseLessonDate20: "Datum und Uhrzeit der 20. gebuchten Einheit(leer wenn Einheit nicht existiert)",

    // ============================================
    // BOOKING - Kursleiter
    // ============================================
    instructorFirstName1: "Vorname des 1. Kursleiters/Trainers",
    instructorLastName1: "Nachname des 1. Kursleiters/Trainers",
    instructorEmail1: "E-Mail-Adresse des 1. Kursleiters",
    instructorFirstName2: "Vorname des 2. Kursleiters/Trainers (falls vorhanden)",
    instructorLastName2: "Nachname des 2. Kursleiters/Trainers (falls vorhanden)",
    instructorEmail2: "E-Mail-Adresse des 2. Kursleiters (falls vorhanden)",
    instructorPhoneNumber1: "Telefonnummer (Festnetz) des 1. Kursleiters/Trainers",
    instructorMobileNumber1: "Mobilnummer (Handy) des 1. Kursleiters/Trainers",
    instructorPhoneNumber2: "Telefonnummer (Festnetz) des 2. Kursleiters/Trainers (falls vorhanden)",
    instructorMobileNumber2: "Mobilnummer (Handy) des 2. Kursleiters/Trainers (falls vorhanden)",

    // ============================================
    // BOOKING - Monatliche Raten (Ratenzahlung)
    // ============================================
    scheduledPaymentCount: "Gesamtanzahl aller Raten",
    scheduledPayments1amount: "Betrag der 1. Rate (formatiert mit Währung)",
    scheduledPayments1due: "Fälligkeitsdatum der 1. Rate",
    scheduledPayments2amount: "Betrag der 2. Rate (formatiert mit Währung)",
    scheduledPayments2due: "Fälligkeitsdatum der 2. Rate",
    scheduledPayments3amount: "Betrag der 3. Rate (formatiert mit Währung)",
    scheduledPayments3due: "Fälligkeitsdatum der 3. Rate",
    scheduledPayments4amount: "Betrag der 4. Rate (formatiert mit Währung)",
    scheduledPayments4due: "Fälligkeitsdatum der 4. Rate",
    scheduledPayments5amount: "Betrag der 5. Rate (formatiert mit Währung)",
    scheduledPayments5due: "Fälligkeitsdatum der 5. Rate",
    scheduledPayments6amount: "Betrag der 6. Rate (formatiert mit Währung)",
    scheduledPayments6due: "Fälligkeitsdatum der 6. Rate",
    scheduledPayments7amount: "Betrag der 7. Rate (formatiert mit Währung)",
    scheduledPayments7due: "Fälligkeitsdatum der 7. Rate",
    scheduledPayments8amount: "Betrag der 8. Rate (formatiert mit Währung)",
    scheduledPayments8due: "Fälligkeitsdatum der 8. Rate",
    scheduledPayments9amount: "Betrag der 9. Rate (formatiert mit Währung)",
    scheduledPayments9due: "Fälligkeitsdatum der 9. Rate",
    scheduledPayments10amount: "Betrag der 10. Rate (formatiert mit Währung)",
    scheduledPayments10due: "Fälligkeitsdatum der 10. Rate",
    scheduledPayments11amount: "Betrag der 11. Rate (formatiert mit Währung)",
    scheduledPayments11due: "Fälligkeitsdatum der 11. Rate",
    scheduledPayments12amount: "Betrag der 12. Rate (formatiert mit Währung)",
    scheduledPayments12due: "Fälligkeitsdatum der 12. Rate",
    scheduledPaymentsOverview: "Tabellarische Übersicht aller Raten mit Datum und Betrag",

    // ============================================
    // BOOKING - Weitere Informationen
    // ============================================
    bookingLastEdited: "Datum und Zeit der letzten Änderung dieser Buchung",
    bookingOnlineBooking: "Wurde die Buchung online vom Bucher selbst durchgeführt: Ja/Nein",
    noticeBooker: "Nachricht/Mitteilung des Buchenden zu dieser Buchung",
    additionalInfo: "Zusatz-Informationen zur Buchung (z.B. ausgewählte Optionen wie Neopren, Badekappen)",
    invoiceNumber: "Rechnungsnummer (falls vorhanden), sonst leer",
    referenceCoursesLink: "HTML-Link zu Folgekursen die durch die Buchung in diesem Kurs verfügbar sind",

    // ============================================
    // BUCHER - im Buchungsmenü (ADR 0004)
    // ============================================
    bookerHouseNumber: "Hausnummer des Buchenden",

    // ============================================
    // RECHNUNG (ADR 0004: bisher ersetzt, aber nicht angeboten)
    // ============================================
    invoiceCreateDate: "Datum der Rechnung (ohne Rechnung: heutiges Datum)",
    paymentDue: "Fälligkeitsdatum der Rechnung, wie es in der Fälligkeitszeile steht (bei Raten die nächste offene Rate; nur in Rechnungsvorlagen befüllt)",
    bookingRNumber: "Nummer der Stornorechnung; ohne Storno die Rechnungsnummer",
    billed: "Ist die Rechnung verbucht: TRUE oder FALSE",
    invoiceCompanyName: "Firma der abweichenden Rechnungsadresse (Teilnehmer vor Bucher), sonst leer",
    invoiceFirstName: "Vorname des Rechnungsempfängers (abweichende Rechnungsadresse, sonst Bucher)",
    invoiceLastName: "Nachname des Rechnungsempfängers (abweichende Rechnungsadresse, sonst Bucher)",
    invoiceAddition: "Adresszusatz der Rechnungsadresse",
    invoiceStreet: "Straße der Rechnungsadresse",
    invoicePostCode: "PLZ der Rechnungsadresse",
    invoiceCity: "Ort der Rechnungsadresse",

    // ============================================
    // ZAHLUNG (ADR 0004: bisher ersetzt, aber nicht angeboten)
    // ============================================
    molliePaymentUrl: "Link zur Online-Zahlung der ersten offenen Mollie-Rate, sonst leer",
    mollieBankTransferRecipient: "Empfänger der Mollie-Überweisung (Stichting Mollie Payments), sonst leer",
    mollieBankTransferIBAN: "IBAN für die Mollie-Überweisung, sonst leer",
    mollieBankTransferBIC: "BIC für die Mollie-Überweisung, sonst leer",
    mollieBankTransferReference: "Verwendungszweck der Mollie-Überweisung, sonst leer",
    mollieBankTransferAmount: "Betrag der offenen Mollie-Überweisung, sonst leer",
    mollieBankTransferDueDate: "Fälligkeit der Mollie-Überweisung, frühestens das Rechnungsdatum; auf Rechnungen zusätzlich begrenzt auf die Gültigkeit der Überweisungsdaten, sonst leer",
    mollieBankTransferValidUntil: "Letzter Tag, an dem Mollie eine Überweisung mit diesen Daten noch zuordnet (nur in Rechnungsvorlagen befüllt), sonst leer",
    paid: "Alle Raten bezahlt und nichts erstattet: true oder false",
    paidDate: "Datum der letzten Zahlung, wenn alles bezahlt ist, sonst leer",
    allPaid: "Alle Raten bezahlt und nichts erstattet: true oder false",
    allPaidDate: "Datum der letzten Zahlung, wenn alles bezahlt ist, sonst leer",
    qrReference: "QR-Referenz der Schweizer QR-Rechnung, sonst leer",
    mandateReference: "SEPA-Mandatsreferenz (Buchung-Kurs-Kunde-Rechnung), nur mit Rechnung",
    bookingIban: "IBAN der bei der Buchung gewählten Zahlungsmethode",
    bookingBankName: "Bank der bei der Buchung gewählten Zahlungsmethode",
    bookingSepaAccountOwner: "Kontoinhaber der bei der Buchung gewählten Zahlungsmethode",
    discount: "Rabattbetrag der Buchung (formatiert mit Währung)",
    discountName: "Bezeichnung des Rabatts, sonst 'Rabatt'",
    memberDiscountAmount: "Mitgliedsrabatt der Buchung (formatiert mit Währung)",
    originalCourseFee: "Kursgebühr vor Rabatt, Mitgliedsrabatt, Gutschrift und Zusatzposten",
    refundTotal: "Summe aller Mollie-Erstattungen (formatiert mit Währung)",
    vat: "MwSt.-Satz mit Zusatz, z.B. '19 % MwSt.'",
    vatAmount: "MwSt.-Betrag der Buchung (formatiert mit Währung)",

    // ============================================
    // FIRMA (ADR 0004: in allen Mails, aus den Unternehmensdaten)
    // ============================================
    organizationName: "Firmenname aus den Stammdaten",
    organizationOwner: "Vor- und Nachname des Inhabers",
    organizationStreet: "Straße der Firmenanschrift",
    organizationStreetNumber: "Hausnummer der Firmenanschrift",
    organizationZipCode: "PLZ der Firmenanschrift",
    organizationCity: "Ort der Firmenanschrift",
    organizationPhone: "Telefonnummer der Firma",
    organizationFax: "Faxnummer der Firma",
    organizationEmail: "E-Mail-Adresse der Firma",
    organizationWebsite: "Website der Firma",
    organizationTaxId: "Umsatzsteuer-Identifikationsnummer bzw. UID der Firma",
    organizationTaxNumber: "Steuernummer der Firma",

    // ============================================
    // UMBUCHUNG (Vorlage „Umbuchung", #664)
    // ============================================
    transferOldBookingNumber: "Buchungsnummer der bisherigen Buchung, z. B. 'B-4711'",
    transferNewBookingNumber: "Buchungsnummer der neuen Buchung im Zielkurs",
    transferOldCourse: "Bisheriger Kurs: Kursart und Kursnummer",
    transferOldCoursePeriod: "Zeitraum des bisherigen Kurses (erste bis letzte Lektion)",
    transferNewCourse: "Neuer Kurs: Kursart und Kursnummer",
    transferNewCoursePeriod: "Zeitraum des neuen Kurses (erste bis letzte Lektion)",
    transferPaidAmount: "Für die bisherige Buchung bereits gezahlter Betrag (formatiert mit Währung)",
    transferAppliedAmount: "Davon auf die Raten der neuen Buchung verrechneter Betrag",
    transferCreditAmount: "Überschuss dieser Umbuchung, der als Guthaben beim Bucher bleibt – '0,00 €', wenn alles verrechnet wurde (nicht der Kontostand)",
    transferCreditBalance: "Guthaben-Saldo des Buchers nach der Umbuchung",
    transferCreditNote: "Satz 'Das verbleibende Guthaben von 20,00 € bleibt bei dir hinterlegt … verrechnet oder auf Wunsch ausgezahlt' – bleibt leer, wenn kein Guthaben übrig ist",
    transferOpenAmount: "Nach dem Übertrag noch offener Betrag der neuen Buchung – '0,00 €', wenn nichts offen ist",
    transferOpenDue: "Fälligkeit der ersten offenen Rate der neuen Buchung – bleibt leer, wenn nichts offen ist",
    transferOpenNote:
        "Sätze zu übernommenen Posten ('Bereits bezahlt und in die neue Buchung übernommen: Badekappe (15,00 €).' / '… im offenen Betrag enthalten: …') und zum offenen Betrag je Zahlart ('Den offenen Betrag von 25,00 € ziehen wir am 17.09.2026 per Lastschrift ein' / '… ist bis … zu zahlen' / '… separate E-Mail mit dem Zahlungslink'), je Satz eine Zeile – bleibt leer, wenn nichts übernommen wurde und nichts offen ist",
    transferDiscountNote: "Satz 'Der Rabatt der bisherigen Buchung (25,00 €) gilt für den neuen Kurs nicht' – bleibt leer, wenn es keinen Rabatt gab oder er übernommen wurde",
    dunningNumber: "Nummer der Mahnung, abgeleitet aus der Rechnungsnummer, z. B. 'M-RE-121-2'",
    dunningLevel: "Stufe der Mahnung, z. B. '2. Mahnung'",
    dunningOpenAmount: "Summe der überfälligen offenen Posten ohne die neue Mahngebühr",
    dunningFeeAmount: "Mahngebühr dieser Mahnung (aus den Einstellungen oder im Dialog angepasst)",
    dunningTotalAmount: "Gesamtforderung: offene Posten plus Mahngebühr",
    dunningDueDate: "Neue Zahlungsfrist als Datum",
    dunningPreviousDates: "Daten der früheren Mahnungen zu dieser Buchung, durch Komma getrennt",
    dunningBankAccount: "Bankverbindung der Schule als Satzteil, z. B. 'auf das Konto IBAN DE12 3456 … (Musterbank, BIC …)'. Leer, wenn in den Firmendaten keine IBAN steht. Bei Einzahlungsschein-Rechnungen mit QR-IBAN: 'mit dem QR-Zahlteil der Mahnung auf das Konto CH44 …'",
    dunningPaymentReference: "Verwendungszweck für die Überweisung: die Rechnungsnummer, z. B. 'RE-121'. Der Bankabgleich ordnet Zahlungen darüber zu. Bei Einzahlungsschein-Rechnungen mit QR-IBAN die QR-Referenz des Zahlteils",
};

/**
 * Hilfsfunktion um die Beschreibung einer Variable zu erhalten
 */
export const getVariableDescription = (variableKey: string): string => {
    return variableDescriptions[variableKey] || "Keine Beschreibung verfügbar";
};
